<div class="report-entity-autocomplete">
  <div class="report-entity-search-control">
    <i nz-icon nzType="search" aria-hidden="true"></i>
    <input
      #searchInput
      nz-input
      role="combobox"
      autocomplete="off"
      [value]="searchText"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [attr.aria-label]="ariaLabel"
      [attr.aria-expanded]="hasPanel"
      [attr.aria-controls]="panelId"
      [attr.aria-activedescendant]="activeDescendant"
      aria-autocomplete="list"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
    />
    <i *ngIf="loading" class="report-entity-spinner" nz-icon nzType="loading" aria-label="Loading results"></i>
    <button
      *ngIf="!disabled && !loading && searchText"
      class="report-entity-clear"
      type="button"
      [attr.aria-label]="'Clear ' + ariaLabel.toLowerCase()"
      (mousedown)="$event.preventDefault()"
      (click)="clear($event)"
    ><i nz-icon nzType="close-circle" aria-hidden="true"></i></button>
  </div>

  <div *ngIf="hasPanel" class="report-entity-suggestions" [id]="panelId" role="listbox">
    <div *ngIf="loading" class="report-entity-state"><i nz-icon nzType="loading" aria-hidden="true"></i> Searching...</div>
    <div *ngIf="!loading && error" class="report-entity-state error">
      <span>{{ error }}</span>
      <button type="button" (mousedown)="$event.preventDefault()" (click)="retry($event)">Retry</button>
    </div>
    <div *ngIf="!loading && !error && attempted && options.length === 0" class="report-entity-state">{{ emptyMessage }}</div>
    <button
      *ngFor="let option of options; let index = index; trackBy: trackById"
      type="button"
      role="option"
      [id]="optionId(option)"
      [class.active]="activeIndex === index"
      [class.selected]="selected?.id === option.id"
      [class.disabled]="option.disabled"
      [disabled]="option.disabled"
      [attr.aria-selected]="selected?.id === option.id"
      [attr.title]="option.title"
      (mouseenter)="activateOption(index, option)"
      (mousedown)="$event.preventDefault()"
      (click)="select(option)"
    >
      <span *ngIf="mode === 'driver'" class="report-entity-avatar">{{ initials(option) }}</span>
      <span *ngIf="mode === 'vehicle'" class="report-entity-avatar"><i nz-icon nzType="car" aria-hidden="true"></i></span>
      <span *ngIf="mode === 'commissionPartner'" class="report-entity-avatar"><i nz-icon nzType="apartment" aria-hidden="true"></i></span>
      <span class="report-entity-copy"><strong>{{ option.label }}</strong><small>{{ option.meta }}</small></span>
      <span *ngIf="mode === 'commissionPartner' && option.rate" class="report-entity-rate">{{ option.rate }}%</span>
      <i *ngIf="selected?.id === option.id" class="report-entity-check" nz-icon nzType="check" aria-hidden="true"></i>
    </button>
  </div>
</div>
